export default __webpack_public_path__ + "static/media/logo.cd736bce.png";